<!-- Entity -->
<!-- DigitalEntity -->
@if (digitalEntity(); as digitalEntity) {
  <div class="block">
    <h1>{{ digitalEntity.title }}</h1>
    <p>{{ digitalEntity.description }}</p>
  </div>
  <div class="block">
    <app-detail-entity [entity]="digitalEntity" />
  </div>
}
<!-- PhysicalEntities -->
@for (physicalEntity of physicalEntities(); track physicalEntity._id) {
  <div class="block">
    <app-detail-entity [entity]="physicalEntity" />
  </div>
}
